export default {
      id: "flex-alignContent-flex-start-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-flex-start-usage",
      toString: function () {
        return this.url;
      }
    }